module.exports = __webpack_public_path__ + "img/stock6.c35f7a0a.png";